// extracted by mini-css-extract-plugin
export var container = "index-module--container--TE9Vl";
export var profile = "index-module--profile--d9Jac";
export var photo = "index-module--photo--vpCkn";
export var aboutMe = "index-module--about-me--3RKZs";
export var title = "index-module--title--1a4YE";
export var content = "index-module--content--I4j9B";
export var itemWrapper = "index-module--itemWrapper--iDF9N";